<template>
  <div ref="wrapperRef" class="translate_wrapper" :class="{ active: isOpen }">
    <div class="current_lang" :class="{ 'current_lang--inverted': invertColor }" @click="toggle">
      <div class="lang">
        <i class="flag-icon" :class="currentOption.icon"></i>
        <span class="lang-txt">{{ currentOption.name }}</span>
      </div>
    </div>

    <div class="more_lang" :class="{ active: isOpen }">
      <div
        class="lang"
        v-for="opt in localeOptions"
        :key="opt.value"
        @click="select(opt)"
      >
        <i class="flag-icon" :class="opt.icon"></i>
        <span class="lang-txt">
          {{ opt.name }}
          <span> ({{ opt.short }})</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { localeOptions } from '@/constants/localization';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  invertColor: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const isOpen = ref(false);
const wrapperRef = ref(null);

const currentOption = computed(
  () => localeOptions.find((opt) => opt.value === props.modelValue) || localeOptions[0]
);

function toggle() {
  isOpen.value = !isOpen.value;
}

function select(opt) {
  isOpen.value = false;
  emit('update:modelValue', opt.value);
  emit('change', opt);
}

function handleClickOutside(event) {
  if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
    isOpen.value = false;
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
</script>

<style lang="scss" scoped>
@import '@/assets/scss/utils/variables';

.current_lang {
  cursor: pointer;
  text-transform: uppercase;
  overflow: hidden;
  border-radius: 5px;
  transition: all 0.3s ease;
  padding: 4px;

  &:hover {
    background-color: rgba($theme-body-sub-title-color, 0.15);
    color: $theme-body-sub-title-color;
  }

  &--inverted {
    color: #fff;

    .lang-txt {
      color: #fff;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      color: #fff;

      .lang-txt {
        color: #fff;
      }
    }
  }
}

.lang {
  span.lang-txt {
    display: inline-flex;
    margin-left: 8px;
    font-weight: 500;
  }

  span span {
    color: #999;
    font-weight: 400;
    margin-left: 5px;
  }
}

.more_lang {
  transform: translateY(-20px);
  opacity: 0;
  cursor: pointer;
  display: none;
  transition: all 0.3s cubic-bezier(0.25, 1.15, 0.35, 1.15);

  &.active {
    opacity: 1;
    transform: translateY(0);
  }

  .lang {
    padding: 10px 15px;
    display: flex;

    &:hover {
      background: var(--theme-default);
      color: $white;

      span {
        color: $white;
      }
    }
  }
}

.translate_wrapper {
  position: relative;

  &.active {
    .more_lang {
      display: block;
      position: absolute;
      background-color: $white;
      top: 100%;
      right: 0;
      box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
      z-index: 10;

      &::before {
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #fff;
        content: '';
        top: -7px;
        position: absolute;
        right: 20px;
        z-index: 2;
      }

      &::after {
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #bdc2c5;
        content: '';
        top: -7px;
        position: absolute;
        right: 20px;
        z-index: 1;
      }

      .lang {
        border-bottom: 1px solid #eaeaea;
      }
    }
  }
}
</style>
